import { s as t, _ as o } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as e from "react";
import { s as a, c as i } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var d = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  o({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, l),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M10.667.314v31.372c-1.733-.204-3.255-.508-4.325-.916C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 1.03-4.918 5.476-6.646C7.412.821 8.934.518 10.667.314Zm10.667 31.384V.318c1.738.207 3.27.52 4.357.945 4.447 1.728 5.476 6.646 5.476 6.646.664 2.757.863 5.582.83 8.107.033 2.493-.2 5.317-.863 8.108 0 0-1.029 4.918-5.477 6.646-1.07.425-2.59.728-4.323.928Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M21.333.318v31.38c-1.654.19-3.502.286-5.333.302a50.558 50.558 0 0 1-5.334-.314V.314A50.525 50.525 0 0 1 16 0c1.83.016 3.676.12 5.333.318Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M12 16.314a3.98 3.98 0 0 0 2.461 3.675.334.334 0 0 1-.255.616 4.638 4.638 0 0 1-.718-8.208.333.333 0 0 1 .358.562A3.972 3.972 0 0 0 12 16.314Zm8 0a3.972 3.972 0 0 0-1.846-3.355.333.333 0 0 1 .359-.562 4.638 4.638 0 0 1-.718 8.208.333.333 0 0 1-.256-.616A3.98 3.98 0 0 0 20 16.314Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M17.061 13.683c-.435-.53-.79-.93-1.532-1.19.001-.003.303-.413-.126-.491-.429-.078-.403.357-.247.48-.078.124-.227.838.408 1.201.594.34 1.24.172 1.247.146.507.518 1.568 3.607-.54 6.14 1.412-.975 2.441-4.25.79-6.286Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#F9F0AA",
      fillRule: "evenodd",
      d: "M14.046 14.755a1.512 1.512 0 0 1-.046-.273c-.002-.155.145-.442.348-.461a66.38 66.38 0 0 1 2.472-.006c.174.153.23.46.13.66.701.976 1.534 2.714.703 3.157-.281-.011-2.92.176-3.143.151 0 0-.244-.152-.29-.407-.057-.312.15-.527.277-.537.09-.01.432-.039.432-.039s-.867-2.197-.883-2.245Z",
      clipRule: "evenodd"
    }
  )
), p = a(d)`
  ${t}
  ${i}
`, E = p;
export {
  E as default
};
